import PageContainer from '../containers/Page';
import { initVisualFilters } from '../modules/VisualFilters';
import '../../styles/templates/_page.sanity.scss';
class PageSanityTemplate extends PageContainer {
    constructor() {
        super();
        super.init();
    }
    init() {
        if (window.UTK_content) {
            if (window.UTK_content.visualFilters) {
                initVisualFilters();
            }
        }
    }
}
$(() => {
    new PageSanityTemplate();
});
